function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, forwardRef } from "react";
import { Table, Row, Col, Divider, Descriptions, Image } from "antd";
import moment from "moment";
import DocumentHeader from "./DocumentHeader";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RistourneDetails = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var bills = _ref.bills;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listOfBills = _useState2[0],
      setListOfBills = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      billsArrayData = _useState4[0],
      setBillsArrayData = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      totalAmount = _useState6[0],
      setTotalAmount = _useState6[1];

  var cols = [{
    title: "Prescripteur",
    dataIndex: "prescriber",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "prescriber"
  }, {
    title: "Nº Facture",
    dataIndex: "bill_id",
    render: function render(text) {
      return /*#__PURE__*/_jsxs("span", {
        children: ["FEMG-", text]
      });
    },
    key: "bill_id"
  }, {
    title: "Montant (GNF)",
    dataIndex: "amount",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "amount"
  }];
  useEffect(function () {
    setBillsArrayData([]);
    bills.forEach(function (b) {
      var ta = 0;
      if (b.prescriber.has_ristourne == 0) return;
      var commission = 0;
      if (b.prescriber.has_ristourne == 0) return;
      b.bill_items.forEach(function (e) {
        if (e.business_account_medical_item.department.dcode == "RAD") commission = 25000;
        if (e.business_account_medical_item.department.dcode == "SCA") commission = 200000;
        if (e.business_account_medical_item.department.dcode == "HIS") commission = 100000;
        ta += commission;
      });
      if (commission != 0) setBillsArrayData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: b.id,
          prescriber: b.prescriber.name,
          bill_id: b.id,
          amount: commission.toLocaleString("Fr")
        }]);
      });
      setTotalAmount(function (prev) {
        return prev + ta;
      });
    });
  }, []);
  return /*#__PURE__*/_jsx("div", {
    id: "printable",
    ref: ref,
    children: /*#__PURE__*/_jsxs("div", {
      className: "watermarked",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(DocumentHeader, {
          title: "FICHE DES RISTOURNES"
        }), /*#__PURE__*/_jsx(Table, {
          size: "small",
          columns: cols,
          bordered: true,
          sticky: true,
          dataSource: billsArrayData,
          pagination: false
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Descriptions, {
          children: /*#__PURE__*/_jsx(Descriptions.Item, {
            valueStyle: {
              fontSize: "36px",
              fontWeigth: "bold"
            },
            label: /*#__PURE__*/_jsx("b", {
              children: "Total (GNF)"
            }),
            children: totalAmount.toLocaleString("fr")
          })
        })]
      })]
    })
  });
});
export default RistourneDetails;